import { gql } from '@apollo/client'

const CreateEndorsementInvitation = gql`
  mutation CreateEndorsementInvitation(
    $input: CreateEndorsementInvitationInput!
  ) {
    createEndorsementInvitation(input: $input) {
      success
      message
    }
  }
`

const RevokeCoachEndorsement = gql`
  mutation RevokeCoachEndorsement($coachEndorsementId: ID!, $reason: String!) {
    revokeCoachEndorsement(
      coachEndorsementId: $coachEndorsementId
      reason: $reason
    ) {
      success
      message
    }
  }
`

const GetCoachFacilitiesAndEndorsements = gql`
  query CoachFacilitiesAndEndorsements {
    currentUser {
      attributes {
        ... on Coach {
          facilities {
            id
            name
          }
        }
      }
    }
    coachEndorsements {
      id
      status
      name
      email
      title
      expiredAt
      facility {
        id
        name
      }
    }
  }
`

export {
  CreateEndorsementInvitation,
  GetCoachFacilitiesAndEndorsements,
  RevokeCoachEndorsement,
}
